<template>
    <div>
        <div class="card">

            <!--cabezera-->
            <div class="card-header">
                <div class="d-flex align-items-center">
                    <div class="flex-fill">
                        <EvaluationAttemptsSearch/>
                    </div>
                    <div >
                        <PrintWindow tooltip="Imprimir tabla" :title="'Evaluaciones'">
                            <PrintableAttemptsTable :items="items"/>
                        </PrintWindow>
                    </div>

                    <div class="float-end">
                        <EvaluationAttemptsPagination/>
                    </div>

                </div>

            </div>

            <div class="card-body">
                <EvaluationAttemptsTable/>
            </div>
        </div>
    </div>
</template>
<script>
import EvaluationAttemptsSearch from './EvaluationAttemptsList/Evaluation-attempts-search.vue'
import EvaluationAttemptsPagination from './EvaluationAttemptsList/Evaluation-attempts-pagination.vue'
import EvaluationAttemptsTable from './EvaluationAttemptsList/Evaluation-attempts-table.vue'
import PrintWindow from '@/components/shared/Print-window.vue';
import PrintableAttemptsTable from './EvaluationAttemptsList/Printable-attempts-table.vue';
import { EventNames } from '@/plugins/enums';

export default {
    name: 'EvaluationAttemptsList',

    components:{
        EvaluationAttemptsSearch,
        EvaluationAttemptsPagination,
        EvaluationAttemptsTable,
        PrintWindow,
        PrintableAttemptsTable
    },

    data() {
        return {
            items: []
        }
    },

    mounted() {
        this.$eventBus.$on(EventNames.EvaluationAttemptsItemsMutation, async (items) => {
            this.items = items
        });
    },
}
</script>
